import {cloneElement, useCallback, useEffect, useRef} from "react";

export default function FocusTrap({isOpened, setIsOpened, dataId="", children}) {
    const trapRef = useRef(null);

    // --- The Ref Merging Function ---
    const setRefs = useCallback(
        (node) => {
            // Your internal ref gets the DOM node
            trapRef.current = node;

            // Get the ref that was originally passed to the child element
            const userRef = children.ref;

            if (typeof userRef === 'function') {
                userRef(node);
            } else if (userRef && typeof userRef === 'object') {
                // Ensure the ref object is mutable (i.e., has a .current property)
                userRef.current = node;
            }
        }, [children.ref] // Only recreate if the user's ref changes
    );

    useEffect(() => {
        const handleKeyDownDropdown = (event) => {
            if (event.key === 'Escape') {
                if (!!setIsOpened) {
                    setIsOpened(false);
                }
                return;
            }

            if (event.key !== "Tab") {
                return;
            }

            let container = dataId ? document.getElementById(dataId) : trapRef.current;
            if (!(container instanceof HTMLElement)) {
                container = container.hasOwnProperty("dialog") ? container = container.dialog : null;
            }

            if (!container) {
                return;
            }

            const focusableElements = container.querySelectorAll('[tabindex]:not([tabindex="-1"])');

            if (!container.contains(event.target)) {
                event.preventDefault();
                focusableElements[0].focus();
                return;
            }

            if (event.shiftKey) {
                for (let i = 0; i < focusableElements.length; i++) {
                    if (focusableElements[i] !== event.target) {
                        continue;
                    }
                    if (i === 0) {
                        event.preventDefault();
                        focusableElements[focusableElements.length - 1].focus();
                        return;
                    } else {
                        event.preventDefault();
                        focusableElements[i - 1].focus();
                        return;
                    }
                }
            } else {
                for (let i = 0; i < focusableElements.length; i++) {
                    if (focusableElements[i] !== event.target) {
                        continue;
                    }
                    if (i === focusableElements.length - 1) {
                        event.preventDefault();
                        focusableElements[0].focus();
                        return;
                    } else {
                        event.preventDefault();
                        focusableElements[i + 1].focus();
                        return;
                    }
                }
            }

        };

        if (!!isOpened) {
            document.addEventListener("keydown", handleKeyDownDropdown);
        }


        return () => {
            document.removeEventListener("keydown", handleKeyDownDropdown);
        };
    }, [isOpened, dataId]);

    // Pass the merging function as the new ref
    return cloneElement(children, {ref: setRefs});
}